import React from 'react'
import Box from '../components/Box'

export default function Section7() {
    return (
        <div className="section">
            <h2>Section VII: Behavior</h2>
            <Box sectionData={'start'} title={'Record Behavior '} body={`Note:  
            • Student photos can be zoomed to full resolution by tapping the photo. 
            1. Select the class as described previously. 
            2. Tap the “Manage” button and select “Behavior” from the menu. 
            3. Tap the “+” button to add a new behavior record. 
            4. Tap  the  “Date”  button  and  select  the  proper  date  for  the  behavior  record.   Todays  date  is 
            selected by default. 
            5. All students default to blank status. Select the appropriate mark for each student. 
            a. Swipe the field and tap “Delete” to clear the entry. 
            6. A notes field will appear when a student has a mark recorded. 
            a. Tap the notes field to enter a note. 
            7. Tap “Done”.`} />

            <Box title={'Add Behavior Notes'} body={`Note:  
            • Notes  can  be  entered  on  a  per-student  basis  or  for  the  behavior  record.  This  procedure  will 
            add a note to the behavior record and will not be associated with an individual student. 
            1. Select the class as described previously.  
            2. Tap the “Manage” button and select “Behavior” from the menu. 
            3. Select the appropriate behavior record entry from the list.  
            4. Tap “Notes”.  
            5. The note field will slide into view.  
            6. Enter or edit class behavior notes.  
            7. Tap “Notes” again to hide the note field.`} />


            <Box title={'Email Students'} body={`1. Select the class as described above. 
            2. Tap the “Manage” button and select “Behavior” from the menu. 
            3. Select the appropriate behavior record entry from the list. 
            4. Tap “Email”. 
            5. A blank email is generated and addressed to all relevant students.`} />



            <Box title={'Edit a Behavior Record '} body={`1. Select the class as described above. 
            2. Tap the “Manage” button and select “Behavior” from the menu. 
            3. Select the appropriate behavior record entry from the list. 
            4. Make the desired changes and tap “Done”.`} />


            <Box title={'Delete a Behavior Record'} body={`Note:  
            • This cannot be undone. 
              
            1. Select the class as described above. 
            2. Tap the “Manage” button and select “Behavior” from the menu. 
            3. Tap the “Edit” button. 
            4. Tap the “-“ button for the record to be deleted. 
            5. Tap “Delete” to confirm. 
            6. Confirm again by tapping ‘Delete Record’. `} />

            <Box title={'Quick Add Behavior Record '} body={`1. Select a class as described above. 
            2. Tap the “Action” button on the bottom toolbar. 
            3. Select “Record Behavior” 
            4. Follow steps (4) – (6) in the “Record Behavior” section above.`} />

            <Box sectionData={'end'} title={'Assign Custom Behavior Labels'} body={`1. Tap the “Settings” button on the bottom toolbar. 
            2. Select “Behavior Entry”. 
            3. Modify the labels as desired.`} />
        </div>
    )
}